import { BER_MAP } from '@propertypal/shared/src/constants/ber';
import epc from '@propertypal/shared/src/resources/icons/epc/epc@3x.png';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const EpcIcon = styled.div`
  background-image: url('${epc.src}');
  background-size: contain;
  width: 70px;
  height: 22px;
  margin-right: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BerIcon = styled.span`
  display: inline-block;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    Segoe UI,
    Helvetica,
    Arial,
    sans-serif,
    Segoe UI Symbol;
  line-height: 1.25;
  overflow: hidden;
  white-space: nowrap;
  vertical-align: middle;
  print-color-adjust: exact !important;
  text-align: left;
  padding-right: 8px;
`;

const BerBadge = css`
  position: relative;
  display: block;
  float: left;
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.white};
  text-decoration: none;
  padding: 2px 0 2px 15px;
  background-color: ${({ theme }) => theme.black};
  pointer-events: none;
  cursor: default;

  &::before {
    border-left: 8px solid #fff;
    margin-left: 3px;
    z-index: 1;
  }

  &::after {
    border-left: 8px solid ${({ theme }) => theme.black};
    z-index: 2;
  }

  &::before,
  &::after {
    content: ' ';
    display: block;
    width: 0;
    height: 0;
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    position: absolute;
    top: 50%;
    margin-top: -16px;
    left: 100%;
  }
`;

export const BerTitle = styled.span`
  ${BerBadge}

  padding-left: 4px;
`;

export const BerRating = styled.span<{ rating: string }>`
  ${BerBadge}

  background-color: ${({ rating, theme }) => BER_MAP[rating] || theme.textOffWhite};
  color: ${({ rating, theme }) => (BER_MAP[rating] ? theme.white : theme.black)};

  &::before {
    border-left: 8px solid transparent;
  }

  &::after {
    border-left-color: ${({ rating, theme }) => BER_MAP[rating] || theme.textOffWhite};
  }
`;
